module.exports = __webpack_public_path__ + "img/icon.67847d8e.png";